<div class="flex-grow-1 w-100 h-100" style="position:relative;">
    <div id="map-container-01" style="width:100%;height:100%;position:relative;"></div>

    <div class="custom_map_control d-flex bg-white p-1">
        <button type="button" class="btn btn-sm btn-outline-info shadow-sm"
            (click)="clickReloadMap()">
            <i class="fas fa-sync fa-fw"></i>
        </button>

        <button type="button" class="btn btn-sm shadow-sm ml-2"
            [class.btn-info]="isShowTraffic === true"
            [class.btn-outline-info]="isShowTraffic === false"
            (click)="clickShowTraffic()">
            <i class="fas fa-traffic-light fa-fw"></i>
        </button>

        <div class="ml-2 input-group input-group-sm shadow-sm">
            <div class="input-group-prepend">
                <button type="button" class="btn btn-outline-info"
                    *ngIf="isMapAutoReload === true"
                    (click)="clickMapAutoReload()">
                    자동갱신
                </button>
                <button type="button" class="btn btn-outline-secondary"
                    *ngIf="isMapAutoReload === false"
                    (click)="clickMapAutoReload()">
                    비갱신
                </button>
            </div>
            <div class="input-group-append">
                <span class="input-group-text border border-left-0 border-secondary">
                    {{getMapAutoReloadTimeDiff() | date:'mm:ss'}}
                </span>
            </div>
        </div>
    </div>
</div>